import {fromJS} from 'immutable';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

import taxActions from '../actions/tax.actions';

export const DEFAULT_STATE = fromJS({
    loading: false,
    organizations: [],
    organization: {},
    record: null,
    isOrg: false,
    taxInterviewUrl: '',
    payAble: false,
    isConsent: false,
    verified: false,
    createAble: true,
    retakeAvailable: false,
    dialogError: '',
    syncAvailable: false,
    isOffline: false
});

export const taxReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case taxActions.TYPES.GET_CONSENT: {
            return newState;
        }

        case taxActions.TYPES.GET_CONSENT_COMPLETE: {
            newState = newState.updateIn(['isConsent'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_CONSENT_FAILED: {
            newState = newState.updateIn(['isConsent'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_RETAKE_UPDATE_COMPLETE: {
            const { syncAvailable, retakeAvailable } = action.payload.data;
            newState = newState.updateIn(['retakeAvailable'], () => retakeAvailable);
            newState = newState.updateIn(['syncAvailable'], () => syncAvailable);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_RETAKE_UPDATE_FAILED: {
            newState = newState.updateIn(['retakeAvailable'], () => false);
            newState = newState.updateIn(['syncAvailable'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE: {
            newState = newState.updateIn(['payAble'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE_COMPLETE: {
            newState = newState.updateIn(['payAble'], () => action.payload.data);
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_BALANCE_PAYABLE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.RETAKE_INTERVIEW_FAILED: {
            if (action.payload.response.data && action.payload.response.data.statusMessage) {
                newState = newState.updateIn(['dialogError'], () => action.payload.response.data.statusMessage);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_EMAIL: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_RECORD_EMAIL_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            if (action.payload.data) {
                newState = newState.updateIn(['organizationEmail'], () => action.payload.data);
            } else {
                newState = newState.updateIn(['organizationEmail'], () => "");
            }
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_PROFILE: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_PROFILE_COMPLETE: {
            // TODO: update tax profile
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['record'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_PROFILE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            const record = action.payload.data;
            if (record) {
                newState = newState.updateIn(['verified'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
                const isOffline = (record.taxVerified && record.paymentHandler === 'epic');
                newState = newState.updateIn(['isOffline'], () => isOffline);
            }
            newState = newState.updateIn(['record'], () => record);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_RECORD_FAILED: {
            if (action.payload && action.payload.response) {
                newState = newState.updateIn(['createAble'], () => action.payload.response.status !== 404);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_INTERVIEW: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case taxActions.TYPES.GET_TAX_INTERVIEW_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.GET_TAX_INTERVIEW_FAILED: {
            if (action.payload.response.data && action.payload.response.data.statusMessage) {
                newState = newState.updateIn(['dialogError'], () => action.payload.response.data.statusMessage);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD_COMPLETE: {
            const record = action.payload.data;
            newState = newState.updateIn(['loading'], () => false);
            if (record) {
                newState = newState.updateIn(['verified'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
            }
            newState = newState.updateIn(['record'], () => record);
            newState = newState.updateIn(['syncAvailable'], () => false);
            return newState;
        }

        case taxActions.TYPES.REFRESH_TAX_RECORD_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }


        case taxActions.TYPES.UPDATE_TAX_RECORD: {
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['record'], () => action.payload);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_RECORD_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            const record = action.payload.data;
            if (record) {
                newState = newState.updateIn(['verified'], () => !!record.recordIdentityKey);
                newState = newState.updateIn(['validated'], () => record.taxVerified);
            }
            newState = newState.updateIn(['record'], () => record);
            return newState;
        }

        case taxActions.TYPES.UPDATE_TAX_RECORD_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT: {
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT_COMPLETE: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['taxInterviewUrl'], () => action.payload.data);
            return newState;
        }

        case taxActions.TYPES.CONSENT_FOR_PAYMENT_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }

        case taxActions.TYPES.RESET_INTERVIEW: {
            newState = newState.updateIn(['taxInterviewUrl'], () => '');
            return newState;
        }

        case taxActions.TYPES.RESET_DIALOG: {
            newState = newState.updateIn(['dialogError'], () => '');
            return newState;
        }

        case taxActions.TYPES.GET_ORGANIZATIONS_COMPLETE: {
            const {data} = action.payload;
            if (data.length) {
                data.forEach(org => {
                    org.value = org.organizationId;
                    org.label = org.name;
                });
            }
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['isOrg'], () => data.organizationEntity);
            newState = newState.updateIn(['organizations'], () => data);
            return newState;
        }
        case taxActions.TYPES.GET_ORGANIZATIONS_FAILED:
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        default:
            return state;
    }
};

export default dieselReducer('tax', taxReducer);
